import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { UserService } from '@rubii/frontend-common';

@Component({
  selector: 'app-channel-factory',
  templateUrl: './channel-factory.component.html',
  styleUrls: ['./channel-factory.component.scss']
})
export class ChannelFactoryComponent extends BaseDatasourceComponent implements OnInit {

  cfEmail = '';

  constructor(private user: UserService) {
    super();
  }

  ngOnInit(): void {
    this.cfEmail = 'report+cf+' + this.user.user.tenant.token + '+' + this.user.user.id + '@rubii.io';
  }

}
